import { useAuthStore } from '@state/stores/auth'
import modalService from '@/services/modal-service'

export interface LibraryEntry {
    onLibraryClick(event: MouseEvent): void
}

// PRD rule 1: logged-out visitors are prompted to log in when they pick Library.
// The route guard still redirects deep links; this is the click-time prompt (D1).
// RouterLink binds its own `navigate` click handler and Vue runs a consumer's
// `@click` AFTER it, so a plain `@click` preventDefault is too late — bind this in
// the capture phase (`@click.capture`) so it runs before navigate (RouterLink's
// guardEvent then sees defaultPrevented and doesn't push).
export function useLibraryEntry(): LibraryEntry {
    const authStore = useAuthStore()

    function onLibraryClick(event: MouseEvent): void {
        if (authStore.loggedIn) return
        event.preventDefault()
        modalService.show('AUTH_REQUIRED_FOR_LIBRARY')
    }

    return { onLibraryClick }
}
